import { Box } from "@material-ui/core";
import { Backdrop, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";
import LogoLoading from "./LogoLoader";

const pulse = keyframes`
  0% { opacity: 0.6; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.05); }
  100% { opacity: 0.6; transform: scale(1); }
`;

export default function LoadingBackdrop({
  open,
  color,
  texto,
  textColor,
}: {
  open: boolean;
  color?: string;
  texto?: string;
  textColor?: string;
}) {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
      open={open}
    >
      {/* <CircularProgress color="inherit" size={80} thickness={4} />{" "} */}
      <LogoLoading />
      <Box mt={3}>
        <Typography
          variant="h6"
          sx={{
            color: textColor ? textColor : "#fff",
            fontSize: "22px",
            fontWeight: "bold",
            textShadow: "0 0 10px rgba(0,0,0,0.7)",
            animation: `${pulse} 2s infinite`,
          }}
        >
          {texto ? texto : "Carregando"}
        </Typography>
      </Box>
    </Backdrop>
  );
}
